import { render } from "./Invest.vue?vue&type=template&id=79bbad6e&scoped=true"
import script from "./Invest.vue?vue&type=script&lang=js"
export * from "./Invest.vue?vue&type=script&lang=js"

import "./Invest.vue?vue&type=style&index=0&id=79bbad6e&lang=scss&scoped=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bbad6e"]])

export default __exports__